module.exports = __webpack_public_path__ + "assets/img/DS-room3 (7).8b58e65a.jpg";